import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE--------------------------------
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { useForm } from "../../../../Base/Hooks/useForm";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import Loader from "../../../../Base/Components/Loader/Loader";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API--------------------------------
import { getCuentasSecundarias } from "../../../../API/Finanzas/RegistroContable/RegistroContableRequest";
import { EditarConstruccion, getConstruccionesPorID, getSubConstrucciones, GuardarConstruccion } from "../../../../API/Global/Construcciones/ConstruccionesRequest";


const ConstruccionesCRUD = ({showDialog, setShowDialog, selected, setSelected, getInfo}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null)
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [cuentas, setCuentas] = useState([]);
  const [subConstrucciones, setSubConstrucciones] = useState([]);
  const [IdsSubContrucciones, setIdsSubconstrucciones] = useState([])


  const initialValues = {
    IdConstruccion: -10,
  };
  
  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    const cuentasTempo = await getCuentasSecundarias()
    setCuentas(cuentasTempo)

    const tempoSubConstrucciones = await getSubConstrucciones()
    setSubConstrucciones(tempoSubConstrucciones.filter(i => i?.IdStatus === 5))

    if(selected?.length > 0){
        const construccionTempo = await getConstruccionesPorID(selected[0]?.IdConstruccion)
        let subs
        if (construccionTempo[0]?.SubConstrucciones?.length > 0) {
            subs = construccionTempo[0]?.SubConstrucciones.split(',')
        } else {
            subs = []
        }
        setIdsSubconstrucciones(subs)
        setValues({
            ...construccionTempo[0],
            Cuenta: construccionTempo[0]?.Cuenta,
            IdCuenta: construccionTempo[0]?.IdCuenta,
        })
    }
    
  };
  
  const verificarInfo = () => {
    let error = {};

    if (!values?.NombreConstruccion) {
        error.NombreConstruccion = true;
        error.error = true;
    }

    if (!values.Cuenta && (!values.IdCuenta || !values?.Cuenta?.IdAccount)) {
        error.IdCuenta = true;
        error.error = true;
    }

    
    setError(error);
    return error;
  };
  
  const AsignarSubConstrucciones = (IdSub, value) => {
    let tempoSubs
    if (IdsSubContrucciones?.length > 0) {
        let s = IdsSubContrucciones?.some((i) => parseInt(i) === IdSub)
        if (s) {
            if (value) {
                tempoSubs = [ ...IdsSubContrucciones ]
            }
            else {
                tempoSubs = IdsSubContrucciones.filter((i) => parseInt(i) !== IdSub)
            }
        } else {
            tempoSubs = [ ...IdsSubContrucciones, `${IdSub}` ]
        }
    } else {
        tempoSubs = [ ...IdsSubContrucciones, `${IdSub}` ]
    }
    let subs = tempoSubs?.toString()
    setIdsSubconstrucciones(tempoSubs)
  }

  const agregarDatos = async () => {
    const e = verificarInfo();
    if (!e.error) {

        let subs = IdsSubContrucciones?.toString()
        let Datos = {
            ...values,
            IdCuenta: values?.Cuenta?.IdAccount || values?.IdCuenta,
            SubConstrucciones : subs,
            IdUserEdit: userAuth?.IdUser,
            IdUserCreate: userAuth?.IdUser,
        }

        setLoading(true)
        let resp
        if(Datos?.IdConstruccion > 0){
            resp = await EditarConstruccion(Datos)
        }else{
            resp = await GuardarConstruccion(Datos)
        }
        if(resp[0]?.ESTADO === 1){
            toastShow(toast, "success", "Datos Agregados", resp[0].MENSAJE);
            setTimeout(() => {                
                setShowDialog(false)
                getInfo()
            }, 700);
        }else{
            toastShow(toast, 'error', 'Error', resp[0]?.MENSAJE);
        }
        setLoading(false)
    }
  }

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => {setShowDialog(false); setSelected([])}}
      />
      <Button
        label={ selected?.length <= 0 ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if(showDialog){
        getValoresIniciales()
    }
  }, [showDialog]);

  return (
    <div>
        <Dialog
            visible={showDialog}
            modal
            className="modal__usuarios"
            footer={DialogFooter}
            onHide={() => {setShowDialog(false); setSelected([])}}
            header={selected?.length <= 0 ? 'Agregar Construcción' : 'Editar Construcción'}
        >
            <div id={'#Dialog'}>
                <Loader loading={loading} querySelector={"#Dialog"} />
                <Toast ref={toast}/>
                <div className="d-flex mx-2">
                    <div className="field col-6 me-2  mt-2">
                        <span className="p-float-label">
                        <InputText
                            name="NombreConstruccion"
                            value={values.NombreConstruccion}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.NombreConstruccion ? "p-invalid" : ""}
                        />
                        <label htmlFor="NombreConstruccion">{getLabel(baseLang, "Nombre", config.language)}</label>
                        </span>
                    </div>
                    <div className="field col-6 me-2 mt-2">
                        <span className="p-float-label">
                        <AutoCompleteDropdown
                            name={"Cuenta"}
                            value={values.Cuenta}
                            items={cuentas}
                            field={"Cuenta"}
                            label={getLabel(baseLang, "Cuenta", config.language)}
                            handleInputChange={handleInputChange}
                            className={error.IdCuenta ? "p-invalid" : ""}
                        />
                        </span>
                    </div>
                </div>

                <div className="d-flex mt-4 mx-2">
                    <div className="field col-12 me-2  mt-2">
                        <span className="p-float-label">
                        <InputText
                            name="Comentario"
                            value={values.Comentario}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.Comentario ? "p-invalid" : ""}
                        />
                        <label htmlFor="Comentario">{getLabel(baseLang, "Comentario", config.language)}</label>
                        </span>
                    </div>
                </div>

                <div>
                    <div className='gridCheckbox'>
                        {
                            subConstrucciones.map((s) => {
                            
                                return (
                                    <div key={s.IdSubContruccion} className='field-checkbox'>
                                        <Checkbox inputId={s.IdSubContruccion} name='category'
                                            value={s.IdSubConstruccion} onChange={(e) => AsignarSubConstrucciones(s.IdSubConstruccion, e.checked)}
                                            checked={IdsSubContrucciones?.some((i) => parseInt(i) === s.IdSubConstruccion)}
                                        />
                                        <label htmlFor={s.IdSubContruccion}>{s.SubConstruccion}</label>
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>
            </div>
        </Dialog>
    </div>
  )
}

export default ConstruccionesCRUD